<div class="input-container">
  <mat-form-field
    class="admin-form-field-outline admin-form-field-outline--shadow admin-form-field-outline--dynamic-height"
    appearance="outline"
    floatLabel="always"
    matTooltipPosition="above"
    matTooltipClass="tag-tooltip"
    [formGroup]="tagsInputForm"
    [matTooltip]="'communications.dialog.tags-hint' | translate"
    [matTooltipShowDelay]="1000"
    [matTooltipHideDelay]="10000">
    <mat-label>Tags</mat-label>
    <mat-chip-grid
      #chipList
      aria-label="Tag selection"
      class="modified-mat-chip-list"
      name="tagsInput"
      formControlName="tagsInput">
      @for (tag of value; track tag) {
        <mat-chip-option
          [selectable]="selectable"
          [removable]="removable"
          (removed)="remove(tag)">
          {{ tag?.name }}
          @if (removable) {
            <mat-icon matChipRemove>cancel</mat-icon>
          }
        </mat-chip-option>
      }
      <input
        #tagInput
        placeholder="Enter new tag..."
        [formControl]="tagsInputCtrl"
        [matAutocomplete]="auto"
        [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        (matChipInputTokenEnd)="add($event)" />
    </mat-chip-grid>
    <mat-autocomplete
      #auto="matAutocomplete"
      (optionSelected)="selected($event)">
      @for (tag of filteredTags; track tag) {
        <mat-option [value]="tag">
          {{ tag?.name }}
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
  @if (loading) {
    <div class="loading">
      <v2-turbine
        [withPole]="false"
        [shadow]="false"></v2-turbine>
    </div>
  }
</div>
